import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";

const Header: React.FC = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <Navbar
      bg="light"
      variant="light"
      expand="lg"
      className="mb-4 border-bottom d-md-none"
    >
      <Container>
        <Navbar.Brand href="/" className="fs-3 fw-bold">
          {t("user.distributor")}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <div className="d-flex" style={{ gap: "10px" }}>
              <Dropdown>
                <Dropdown.Toggle variant="info" id="languageDropdown">
                  Language
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    key={"en"}
                    onClick={() => changeLanguage("en")}
                  >
                    {"English"}
                  </Dropdown.Item>
                  <Dropdown.Item
                    key={"ko"}
                    onClick={() => changeLanguage("ko")}
                  >
                    {"Korean"}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
